<template>
    <div class="box">
        <div class="tree">
            <el-input placeholder="输入关键字进行过滤" v-model="filterText">
            </el-input>

            <el-tree class="filter-tree" :data="classifyList" :props="defaultProps" @node-click="handleNodeClick"
                default-expand-all :filter-node-method="filterNode" ref="tree" highlight-current>
            </el-tree>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filterText: '',
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            classifyList: [],
            returnData: {
                list: []
            }
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    created() {

    },
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        openBox() {
            this.queryClassify()
        },
        async queryClassify() {
            let responseData = await this.$http.carouseClassifyqueryList({})
            if (responseData.status == 200) {
                this.returnData.list = responseData.result
                this.classifyList = this.handleJurisdiction(responseData.result)
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    value['id'] = value['id']
                    value['value'] = value['id']
                    value['label'] = value['className']
                    value['contentUrl'] = value['contentUrl']
                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['disabled'] = true
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    } else {
                        value['disabled'] = false
                    }
                    son.push(value)

                }
            })
            return son;
        },
        handleNodeClick(data) {
            console.log(data);
            var arr = this.returnData.list.filter(item => item.parentId == data.value)
            if (arr.length == 0) {
                this.$emit('paramToHome', '/homePage', true, {
                    item: {
                        classId: data.value
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
.box {
    min-height: calc(100vh - 80px);
    background-color: #e6e6e6;
}

.tree {
    width: 1000px;
    min-height: calc(100vh - 80px);
    padding: 10px;
    background-color: #fff;
    margin: 0 auto;
    /* overflow: auto; */
}
.filter-tree{
    overflow: auto;
    height: calc(100vh - 155px);
    margin-top: 10px;
}
</style>